import React, { ReactNode } from 'react'
import Image from '@components/Image'
import { Col, Container, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData, RealEstateSocial } from 'types'

const Small_Footer_1 = (props: RealEstateDataPageComponentData) => {
  const {
    global_data,
    paragraphHexa,
    titleHexa,
    backgroundHexa,
    customFontSize,
    height,
    backgroundColor,
    columns,
  } = props

  const getCurrentYear = (): number => new Date().getFullYear()

  const isDesktop = () => (screen.width < 992 ? false : true)

  return (
    <footer
      className="footer e"
      style={{
        borderTop: `${columns === 'top' ? height?.desktop : 0}px solid ${backgroundColor}`,
        borderBottom: `${columns === 'bottom' ? height?.desktop : 0}px solid ${backgroundColor}`,
      }}
    >
      <div
        className="text-content"
        style={{ backgroundColor: backgroundHexa, fontSize: customFontSize + 'rem' }}
      >
        <p
          className="copy text-center"
          style={{ color: paragraphHexa, fontSize: customFontSize + 'rem' }}
        >
          Promoted by{' '}
          <a
            style={{ color: titleHexa, fontSize: customFontSize + 'rem' }}
            target="_blank"
            href="https://mediahaus.com.ar"
          >
            {' '}
            MediaHaus
          </a>{' '}
          - Powered by{' '}
          <a
            style={{ color: titleHexa, fontSize: customFontSize + 'rem' }}
            target="_blank"
            href="https://mediacore.app/"
          >
            {' '}
            MediaCore
          </a>
          <br />
          <span
            style={{ color: paragraphHexa, fontSize: (customFontSize || 1) * 0.9 + 'rem' }}
            className="small-text"
          >
            Todos los derechos reservados ® {getCurrentYear()}
          </span>
        </p>
      </div>
    </footer>
  )
}

export default Small_Footer_1
